<template>
  <div>
    <c-card reference="Climb administração > início" title="Início">
      <div>
        <b-row>
          <b-col cols="12">
            <c-card title="Geral" id="graficoCampanhas">
              <span v-if="usuariosFiltrados"
                >Usuários filtrados: {{ usuariosFiltrados }}</span
              >
              <span v-if="campanhasFiltradas"
                >Campanhas filtradas: {{ campanhasFiltradas }}</span
              >
              <template slot="icons">
                <icon class="icon fa-lg" @click="abrirFiltros" icon="filter">
                  <span v-if="totalFilters" class="card-icons-alert">{{
                    totalFilters
                  }}</span>
                </icon>
              </template>
              <div v-if="!campanhas" class="d-flex p-3 justify-content-center">
                <b-spinner
                  class="mr-2"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
                <label>Carregando...</label>
              </div>
              <div
                v-if="flg_campanhas"
                class="d-flex p-3 justify-content-center m-2"
              >
                <label>Não há campanhas.</label>
              </div>
              <div v-else>
                <chart
                  v-if="campanhas"
                  type="bar"
                  :options="graficoCampanhas.chartOptions"
                  :series="graficoCampanhas.series"
                ></chart>
              </div>
            </c-card>
          </b-col>
          <b-col cols="12" md="12" lg="12" xl="4">
            <c-card title="Enviados">
              <div v-if="!envios" class="d-flex p-3 justify-content-center m-2">
                <b-spinner
                  class="mr-2"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
                <label>Carregando...</label>
              </div>
              <div
                v-if="flg_envios"
                class="d-flex p-3 justify-content-center m-2"
              >
                <label>Sem envios.</label>
              </div>
              <div v-else>
                <chart
                  v-if="envios"
                  type="donut"
                  height="200"
                  :options="graficoEnviosHoje.chartOptions"
                  :series="graficoEnviosHoje.series"
                ></chart>
              </div>
            </c-card>
          </b-col>
          <b-col cols="12" md="12" lg="12" xl="4">
            <c-card title="Visualizados">
              <div
                v-if="!visualizados"
                class="d-flex p-3 justify-content-center m-2"
              >
                <b-spinner
                  class="mr-2"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
                <label>Carregando...</label>
              </div>
              <div
                v-if="flg_visualizados"
                class="d-flex p-3 justify-content-center m-2"
              >
                <label>Sem visualizações.</label>
              </div>
              <div v-else>
                <chart
                  v-if="visualizados"
                  type="donut"
                  height="200"
                  :options="graficoVisualizadosHoje.chartOptions"
                  :series="graficoVisualizadosHoje.series"
                ></chart>
              </div>
            </c-card>
          </b-col>
          <b-col cols="12" md="12" lg="12" xl="4">
            <c-card title="Retornos">
              <div
                v-if="!retornos"
                class="d-flex p-3 justify-content-center m-2"
              >
                <b-spinner
                  class="mr-2"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
                <label>Carregando...</label>
              </div>
              <div
                v-if="flg_retornos"
                class="d-flex p-3 justify-content-center m-2"
              >
                <label>Sem retornos.</label>
              </div>
              <div v-else>
                <chart
                  v-if="retornos"
                  type="donut"
                  height="200"
                  :options="graficoRetornosHoje.chartOptions"
                  :series="graficoRetornosHoje.series"
                ></chart>
              </div>
            </c-card>
          </b-col>
        </b-row>
      </div>
    </c-card>
    <c-modal
      title="Filtro"
      v-model="modalFiltro"
      size="md"
      class="overflow-visible"
    >
      <template v-slot:buttons>
        <button @click="filtrarCampanhas">Filtrar</button>
      </template>

      <b-row>
        <b-col>
          <b-form-group
            label-size="md"
            label="Usuário"
            label-for="filtro-usuario"
          >
            <c-multiselect
              id="filtro-usuario"
              v-model="temporaryFilters.usuarios"
              :options="optionsUsuarios"
              class="mb-3"
              @input= "loadCampanhaFiltro"
              style="z-index: 3 !important;"
            ></c-multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Situação da Campanha" label-for="filtro-sit_campanha" >
                <b-form-select
                  id="filtro-sit_campanha"
                  v-model="temporaryFilters.sit_campanha"
                  :options="opcoesSituacaoCampanhaFiltro"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  @change="loadCampanhaFiltro">
                    <template v-slot:first>
                      <option :value="1">Ativas</option>
                    </template>
              </b-form-select>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-size="md"
            label="Campanha"
            label-for="filtro-campanha"
          >
         <!-- <input type="checkbox" id="campanhaAtivas" v-model="checked">
          <label for="campanhaAtivas">Somente campanha ativas</label> -->

            <c-multiselect
              id="filtro-campanha"
              v-model="temporaryFilters.campanha"
              :options="optionsCampanhaFiltro"
              class="mb-3"
              style="z-index: 2 !important;"
            ></c-multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label-size="sm" label="Classificação do Retorno" label-for="filtro-ind_aval" data-toggle="tooltip" title="Quando aplicado o filtro de classificação, somente os gráficos referentes aos retornos serão atualizados">
        <b-form-select
          id="filtro-ind_aval"
          v-model="temporaryFilters.ind_aval"
          :options="opcoesClassificacaoFiltro"
          class="mb-3"
          value-field="item"
          text-field="name">
            <template v-slot:first>
              <option :value="null"></option>
            </template>
      </b-form-select>
    </b-form-group>

    <!--<b-row>
        <b-form-group style="padding-left: 20px;" label-size="sm" label="Período:" title="Período"></b-form-group>
    </b-row>

    <b-row>
      <b-form-datepicker size="sm" id="filtro-mesano" :hide-header="true" :date-format-options="{ year: 'numeric', month: 'numeric', day: undefined }" v-model="temporaryFilters.mesano" class="mb-2"></b-form-datepicker>
      </b-row>-->

    <!--<b-row>
        <b-form-group style="padding-right: 0px; padding-left: 20px; flex-wrap: unset" label-cols="2"  label-size="sm" label="De:" label-for="filtro-periodo_inicio" title="Período">
            <b-form-input size="sm" type="date" id="filtro-periodo_inicio" v-model="temporaryFilters.periodo_inicio" ></b-form-input>
        </b-form-group>

        <b-form-group style="padding-right: 0px; padding-left: 20px; flex-wrap: unset; " label-cols="2"  label-size="sm" label="Até:" label-for="filtro-periodo_fim" title="Período">
            <b-form-input size="sm" type="date" id="filtro-periodo_fim" v-model="temporaryFilters.periodo_fim" ></b-form-input>
        </b-form-group>
    </b-row>-->

    </c-modal>
    <c-modalList
      :title="tituloModal"
      :items="contatos"
      v-model="modalContatos"
      size="full"
    >

    


      <template id="my-table" v-slot:items="item">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex flex-column">
            <div>
              <span style="font-size: .9em; color: #222; font-weight: bold;">{{
                item.data.nome
              }}</span>
              da
              <span style="font-size: .9em; color: #222; font-weight: bold;">{{
                item.data.empresa
              }}</span>
              <br><span style="font-size: .8em; color: #6f6f6f">{{item.data.email}}</span>
              <div v-if="tituloModal === 'Retornos'"> Retorno:
                <span :class="spanStyle(item.data.ind_avaliacao)"> {{
                  mostrarClassificacao(item.data.ind_avaliacao)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:modalPage><span style="font-size: .8em;font-weight: bold;">
                {{ (page - 1) * limit + 1 }} -
                {{ page * limit > totalRows ? totalRows : page * limit }} /
                {{ totalRows }}
              </span>
              <b-pagination
                v-model="page"
                :total-rows="totalRows"
                :per-page="limit"
                aria-controls="my-table"
                pills
                size="sm"
                class="mb-0"
              ></b-pagination></template>

  </c-modalList>
    
  </div>
</template>

<script>
import relatorioService from "@/services/relatorioService.js";
import usuarioService from "@/services/usuarioService.js";
import campanhaService from "@/services/campanhaService.js";

import CCard from "@/components/CCard.vue";
import CModal from "@/components/CModal.vue";
import CModalList from "@/components/CModalList.vue";
import CMultiselect from "@/components/CMultiselect.vue";
import Chart from "vue-apexcharts";

export default {
  name: "Inicio",
  components: {
    CCard,
    Chart,
    CModal,
    CModalList,
    CMultiselect
  },
  data() {
    return {
      enviosCampanha: [],
      retornosCampanha: [],
      contatosCampanha: [],
      contatos: [],
      origens: [],
      limit: 15,
      page: 1,
      totalRows: 0,
      temporaryFilters: {},
      filters: {
        usuarios_id: null,
        sit_campanha: 1,
        campanha: null,
        ind_aval: null,
        periodo_inicio: null,
        periodo_fim: null,
        mesano: null,
      },
      usuariosFiltrados: null,
      campanhasFiltradas: null,
      modalTemplate: false,
      assunto: null,
      mensagem: null,
      contato: {},
      origem: null,
      campanhas: false,
      envios: false,
      visualizados: false,
      retornos: false,
      flg_campanhas: false,
      flg_envios: false,
      flg_visualizados: false,
      flg_retornos: false,
      modalEnvios: false,
      modalVisualizacoes: false,
      modalRetornos: false,
      modalContatos: false,
      modalContatosBloqueados: false,
      modalFiltro: false,
      loading: false,
      tituloModal: "Contatos",
      opcoesStatusFiltro: [
        { item: "1", name: "Ativa" },
        { item: "2", name: "Inativa" },
        { item: null, name: "Ambos" }
      ],
      usuarios: [],
      campanhaFiltro: [],
      opcoesClassificacaoFiltro: [
                { item: '1', name: 'Sem classificação'},
                { item: '2', name: 'Neutra' },
                { item: '3', name: 'Com interesse' },
                { item: '4', name: 'Sem Interesse' },
              ],
      opcoesSituacaoCampanhaFiltro: [
                { item: '2', name: 'Inativas' },
                { item: null, name: 'Todas' },
              ],
    };
  },
  methods: {
    loadRelatorio() {
      relatorioService
        .getAll(this.filters)
        .then(res => {
          this.campanhas = res.data.data.campanhas;
          this.retornos = res.data.data.retornos;
          this.envios = res.data.data.envios;
          this.visualizados = res.data.data.visualizados;


          this.campanhas.length == 0
            ? (this.flg_campanhas = true)
            : (this.flg_campanhas = false);
          this.envios.length == 0
            ? (this.flg_envios = true)
            : (this.flg_envios = false);
          this.visualizados.length == 0
            ? (this.flg_visualizados = true)
            : (this.flg_visualizados = false);
          this.retornos.length == 0
            ? (this.flg_retornos = true)
            : (this.flg_retornos = false);
        })
        .catch(error => {
          error = "Algo deu errado ao carregar relatório 😢";
          this.notificate({ text: error, variant: "danger" });
        });
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    filtrarCampanhas() {
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));

      let usuarios = [];

      Object.keys(this.usuarios).forEach(k => {
        if (this.temporaryFilters.usuarios.includes(this.usuarios[k].id)) {
          usuarios.push(this.usuarios[k].nome);
        }
      });

      this.usuariosFiltrados = usuarios.join(", ");

      let campanhas = [];

      Object.keys(this.campanhaFiltro).forEach(k => {
        if (this.temporaryFilters.campanha.includes(this.campanhaFiltro[k].id)) {
          campanhas.push(this.campanhaFiltro[k].nome);
        }
      });

      this.campanhasFiltradas = campanhas.join(", ");

      this.loadRelatorio();
    },
    loadUsuarios() {
      usuarioService
        .list()
        .then(res => {
          this.usuarios = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });

      this.loadRelatorio();
    },
    loadCampanhaFiltro() {
      //his.filters = JSON.parse(JSON.stringify(this.temporaryFilters.usuarios));
      
      campanhaService
        .list(this.temporaryFilters.usuarios,this.temporaryFilters.sit_campanha)
        .then(res => {
          this.campanhaFiltro = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });

      this.loadRelatorio();
    },
    clickCampanha(event, chartContext, config,pageNumber) {
      if (config.seriesIndex == -1) return false;
      relatorioService
        .getContatos(
          this.limit,
          pageNumber,
          this.filters,
          config.globals.labels[config.dataPointIndex],
          config.seriesIndex
        )
        .then(res => {
          this.contatos = res.data.data;
          this.totalRows = res.data.totalRows;

          if (config.seriesIndex == 0) {
            this.tituloModal = "Enviados";
          } else if (config.seriesIndex == 1) {
            this.tituloModal = "Retornos";
          } else if (config.seriesIndex == 2) {
            this.tituloModal = "Visualizados";
          }

          this.modalContatos = true;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    mostrarClassificacao(ind_avaliacao){

      let classificacao = ''
        if (ind_avaliacao == null) classificacao = "Sem Classificação";
        if (ind_avaliacao == 2) classificacao = "Neutro";
        if (ind_avaliacao == 3) classificacao = "Com Interesse";;
        if (ind_avaliacao == 4) classificacao = "Sem Interesse";

        return classificacao;
    },
    spanStyle(ind_avaliacao) {
      let spanClass = ''
        if (ind_avaliacao == null) spanClass = "badge badge-secondary"
        if (ind_avaliacao == 2) spanClass = "badge bg-warning text-light"
        if (ind_avaliacao == 3) spanClass = "badge badge-success text-light"
        if (ind_avaliacao == 4) spanClass= "badge badge-danger text-light"

        return spanClass
    }

  },
  computed: {
    graficoCampanhas() {
      return {
        series: [
          { name: "Enviados", data: this.campanhas.map(o => o.envios) },
          { name: "Retornos", data: this.campanhas.map(o => o.retornos) },
          {
            name: "Visualizados",
            data: this.campanhas.map(o => o.visualizados)
          }
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 430,
            events: {
              click: this.clickCampanha
            }
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top"
              }
            }
          },
          dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {
              fontSize: "12px",
              colors: ["#fff"]
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ["#fff"]
          },
          xaxis: {
            categories: this.campanhas.map(o => o.nome)
          }
        }
      };
    },
    graficoEnviosHoje() {
      return {
        series: this.envios.map(o => o.envios),
        chartOptions: {
          labels: this.envios.map(o => o.nome),
          chart: {
            type: "donut"
          },
          dataLabels: {
            enabled: false
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    fontSize: "1em",
                    offsetY: 0
                  },
                  total: {
                    show: true
                  }
                }
              }
            }
          }
        }
      };
    },
    graficoVisualizadosHoje() {
      return {
        series: this.visualizados.map(o => o.visualizados),
        chartOptions: {
          labels: this.visualizados.map(o => o.nome),
          chart: {
            type: "donut"
          },
          dataLabels: {
            enabled: false
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    fontSize: "1em",
                    offsetY: 0
                  },
                  total: {
                    show: true
                  }
                }
              }
            }
          }
        }
      };
    },
    graficoRetornosHoje() {
      return {
        series: this.retornos.map(o => o.retornos),
        chartOptions: {
          labels: this.retornos.map(o => o.nome),
          chart: {
            type: "donut"
          },
          dataLabels: {
            enabled: false
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    fontSize: "1em",
                    offsetY: 0
                  },
                  total: {
                    show: true
                  }
                }
              }
            }
          }
        }
      };
    },
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    },
    optionsUsuarios() {
      return this.usuarios.map(o => ({
        value: o.id,
        text: o.id + ' - ' + o.nome
      }));
    },
    optionsCampanhaFiltro() {
        return this.campanhaFiltro.map(o => ({
            value: o.id,
            text: o.id + ' - ' + o.nome
        }));
    },
  },
  mounted() {
    this.loadRelatorio();
    this.loadUsuarios();
    //this.loadCampanhaFiltro();
  }
};
</script>

<style>
.flex-grow-1.container-fluid.p-5.h-100.overflow-auto {
  overflow: auto !important;
}
</style>
